export const FEATURE_NAME = '@zerops/zui/user-data-add-form';
